import type { TemplateOnlyComponent } from '@ember/component/template-only';

export interface Signature {
  Args: {
    class?: string;
  };
  Element: SVGElement;
}

const WrExclamationIconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    class={{@class}}
    ...attributes
  >
    <path
      d='M8.5 11.3C8.5 11.7 8.2 12 7.8 12C7.4 12 7.1 11.7 7.1 11.3C7.1 10.9 7.4 10.6 7.8 10.6C8.2 10.6 8.5 10.9 8.5 11.3ZM7.9 3.8C7.5 3.8 7.2 4.1 7.2 4.5V9.2C7.2 9.6 7.5 9.9 7.9 9.9C8.3 9.9 8.6 9.6 8.6 9.2V4.5C8.5 4.1 8.2 3.8 7.9 3.8ZM15 8C15 11.9 11.9 15 8 15C4.1 15 1 11.9 1 8C1 4.1 4.1 1 8 1C11.9 1 15 4.1 15 8ZM13.8 8C13.8 4.8 11.2 2.2 8 2.2C4.8 2.2 2.2 4.8 2.2 8C2.2 11.2 4.8 13.8 8 13.8C11.2 13.8 13.8 11.2 13.8 8Z'
      fill='currentColor'
    />
  </svg>
</template>;

export default WrExclamationIconComponent;
